import { render, staticRenderFns } from "./LpInput.vue?vue&type=template&id=42953610&scoped=true"
import script from "./LpInput.vue?vue&type=script&lang=js"
export * from "./LpInput.vue?vue&type=script&lang=js"
import style0 from "./LpInput.vue?vue&type=style&index=0&id=42953610&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42953610",
  null
  
)

export default component.exports